import { render, staticRenderFns } from "./ChuFangList.vue?vue&type=template&id=368994b6&scoped=true"
import script from "./ChuFangList.vue?vue&type=script&lang=js"
export * from "./ChuFangList.vue?vue&type=script&lang=js"
import style0 from "./ChuFangList.vue?vue&type=style&index=0&id=368994b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368994b6",
  null
  
)

export default component.exports